{
  "account": {
    "title": "我的账户",
    "list": {
      "title": "账户列表",
      "description": "已关联账户的发票列表"
    },
    "form": {
      "name": {
        "title": "名称",
        "description": "您的账户名称"
      },
      "password": {
        "title": "密码",
        "description": "为您的账户设置新密码，留空则保留当前密码"
      },
      "emailPreferences": {
        "title": "邮件偏好设置",
        "description": "选择邮件通知类型"
      }
    },
    "billing": "账单详情",
    "subscriptions": "订阅",
    "manageSubscription": "管理订阅",
    "popup": {
      "cancel": "您确定要取消订阅吗？<br/>您的网站将继续翻译，直到当前订阅期结束。此后，翻译将被禁用。<br/>请注意，未使用期间恕不退款。",
      "downgrade": "您确定要降级吗？降级将立即生效。<br/>请注意，当前计费周期剩余时间恕不退款。<br/>新方案价格将在下个计费周期生效。",
      "default": "您确定要更改方案吗？",
      "resume": "您确定要恢复订阅吗？"
    }
  },
  "ai_translation": {
    "header": "AI 翻译",
    "plan": {
      "header": "AI 翻译定价",
      "used": "您已使用 {words_used} / {words_allowed} 个 AI 积分的翻译字数。",
      "remaining": "可用 AI 积分：",
      "words": "字",
      "add_more_credits": "增加 AI 积分",
      "details": {
        "idiomatic_expressions": "习惯用语与技术表达",
        "background_translation": "后台翻译",
        "best_website": "需要完美翻译质量的网站",
        "page_context": "页面与网站上下文翻译",
        "perfect_quality": "完美质量，实惠价格",
        "no_recurring": "无需循环付款，预付费配额",
        "save_40": "比 $20 方案节省 40%",
        "save_50": "比 $20 方案节省 50%"
      },
      "quota": "{estimated_words} 字 ≈ {estimated_pages} 页"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI 翻译",
        "intro": "Linguise 隆重推出 Linguise AI 翻译，这一全新高级功能采用 AI LLM 模型（最新版 Llama，专为翻译任务优化）。专为追求极致准确度的网站设计，兼顾页面与整个网站上下文，带来无与伦比的效果。为您的客户提供巅峰翻译品质，确保信息在任何语言中都完美共鸣。",
        "button": "立即升级"
      },
      "alert": {
        "description": "当前方案不包含此功能，需单独购买。\n激活此插件即可解锁下方所有选项。"
      },
      "languages": {
        "title": "将 AI 翻译应用于语言",
        "description": "选择需应用 AI 翻译的具体语言"
      },
      "button": {
        "save": "保存设置"
      },
      "form": {
        "advanced": {
          "title": "高级 AI 指令",
          "description": "高级 AI 指令"
        },
        "enable_mode": {
          "title": "启用 AI 翻译",
          "description": "选择 AI 翻译启用方式。\n仅规则将仅应用以下规则。\n仅实时编辑器将允许在实时编辑器视图中逐页启用翻译。\n规则与实时编辑器将同时使用两项功能。",
          "disabled": "已禁用",
          "rules": "仅规则",
          "live_editor": "仅实时编辑器",
          "all": "规则与实时编辑器"
        },
        "rule_application": {
          "description": "将 AI 翻译应用于静态内容、动态内容或两者",
          "title": "应用于内容",
          "all": "所有内容",
          "static": "静态内容",
          "dynamic": "动态内容"
        },
        "website_topic": {
          "title": "网站主题",
          "placeholder": "寿司餐厅...",
          "description": "为提升翻译质量，请用英文定义网站主题（如法律、寿司餐厅、自行车零件电商…）"
        },
        "apply_to_urls": {
          "title": "应用于 URL",
          "description": "选择需应用 AI 翻译的具体 URL",
          "all_urls": "所有 URL",
          "selected_urls": "选定 URL",
          "label": "要应用的 URL",
          "placeholder": "要应用的 URL",
          "wildcard": "通配符",
          "regex": "正则表达式",
          "add": "新增",
          "expression": "表达式类型"
        },
        "apply_languages": {
          "title": "应用于语言",
          "description": "选择需应用 AI 翻译的具体语言",
          "all_languages": "所有语言",
          "selected_languages": "选定语言",
          "placeholder": "选择语言...",
          "feedback": "必须选择一种语言"
        },
        "formality": {
          "title": "正式度",
          "description": "指定翻译的正式程度，可能对受众和场景很重要。\n“中性”将尽量保留原文的正式度。\n“正式”适用于专业、商务或法律内容（如西班牙语使用“usted”）。\n“非正式”适用于休闲对话内容（如西班牙语使用“tú”）。",
          "neutral": "中性",
          "formal": "正式",
          "informal": "非正式"
        },
        "sentence_structure": {
          "classic": "经典",
          "short": "简短有力句",
          "detailed": "详细说明句",
          "title": "句子结构",
          "description": "定义写作风格偏好。"
        },
        "content_purpose": {
          "marketing": "营销/推广（说服力强、引人入胜）",
          "technical": "技术/指导（清晰、精确、行动导向）",
          "support": "客户支持（共情、乐于助人、令人安心）",
          "legal": "法律/合规（精确、正式、无歧义）",
          "educational": "教育（清晰、结构化、易懂）",
          "other": "其他（请用英文填写）",
          "title": "内容目的",
          "description": "定义被翻译内容的功能目的。",
          "other_placeholder": "请描述目的..."
        },
        "target_audience": {
          "title": "目标受众",
          "description": "请用英文说明翻译内容的目标受众。",
          "placeholder": "例如，讲西班牙语的父母，欧盟隐私专员"
        },
        "override_default_translations": {
          "title": "覆盖默认翻译",
          "description": "若设为“是”，即使内容已由 Cloud AI 翻译（默认翻译模型）翻译，仍将强制使用 AI（Linguise AI）重新翻译。"
        },
        "force_replace_before": {
          "title": "强制 AI 重新翻译",
          "description": "使用 AI 重新翻译所选日期之前完成 AI 翻译的所有内容，例如使用旧模型翻译的内容。根据规则，在相关页面下次被访问时进行重新翻译，并使用您的 AI 额度。",
          "before_date": "某日期之前"
        },
        "model": {
          "current": "当前",
          "title": "模型",
          "description": "选择您想要使用的LLM翻译模型",
          "load_error": "无法加载可用模型。请稍后再试。",
          "thinking_warning": "此模型使用高水平的推理（\"思考\"），每次翻译将消耗更多的令牌。"
        },
        "override_manual_and_selected": {
          "no_default": "否（默认）",
          "title": "覆盖手动翻译和选定的翻译",
          "description": "默认情况下，您手动编辑过的翻译始终显示在网站上，即使已生成 AI 增强翻译。设为“是”则改为显示 AI 增强翻译。您的手动翻译会被保留，可随时切换回来。这也适用于您重新翻译页面以获取新翻译的情况，系统会自动使用最新的翻译。"
        }
      },
      "message": {
        "save_success": "在当前已翻译内容中，约有 {{ai_affected_urls}} 个页面将通过 AI 翻译进一步提升。",
        "save_success_only": "设置保存成功。"
      }
    },
    "pricing": {
      "plan": {
        "title": "订购 AI 翻译配额",
        "buy_button": "购买 AI 翻译套餐"
      },
      "modal": {
        "title": "确认方案变更",
        "description": "您确定要更改 AI 翻译方案吗？",
        "button_cancel": "取消",
        "button_confirm": "确认",
        "loading": "请稍候...",
        "amount": "金额",
        "credit": "积分",
        "total_due": "应付总额"
      },
      "comparison": {
        "title": "Google Cloud AI 翻译\n对比 Linguise AI 翻译",
        "list": {
          "0": {
            "google": "快速、可靠的翻译",
            "linguise": "处理习语和技术表达"
          },
          "1": {
            "google": "即时翻译网站所有页面",
            "linguise": "在后台生成翻译"
          },
          "2": {
            "google": "高质量、低价格",
            "linguise": "完美质量、价格实惠"
          },
          "3": {
            "google": "最适合大型网站或低预算",
            "linguise": "最适合需要完美翻译质量的网站"
          },
          "4": {
            "google": "页面上下文翻译",
            "linguise": "页面+网站上下文翻译"
          }
        }
      },
      "botom_banner": {
        "title": "体验无与伦比的翻译精度：",
        "sub_title": "全新 Linguise AI 翻译",
        "description": "Linguise 正在通过 Linguise AI 翻译提升其自动翻译服务，这是一种利用前沿 AI 翻译 LLM（针对翻译进行优化的最新 Llama 模型）的强大新选择。这一升级可为网站开发者及代理商提供更高层次的翻译质量，非常适合对完美要求极高的项目。Linguise AI 翻译与我们现有高质量的 Google Cloud AI 翻译互为补充，为您提供更大的灵活性与精确度。"
      }
    },
    "success": {
      "tab_title": "感谢您的 AI 翻译套餐购买！",
      "title": "感谢您的 AI 翻译套餐购买！",
      "subtitle": "您的 AI 翻译套餐已成功购买！",
      "message": "您可在 AI 翻译设置页面管理您的 AI 翻译套餐。",
      "home": "管理 AI 翻译"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "姓名",
        "description": "账单账户姓名"
      },
      "phone": {
        "title": "电话",
        "description": "账单账户电话"
      },
      "email": {
        "title": "电子邮箱",
        "description": "账单账户电子邮箱"
      },
      "address": {
        "title": "地址",
        "description": "账单账户地址",
        "city": "城市",
        "country": "国家",
        "address1": "地址 1",
        "address2": "地址 2",
        "postal": "邮政编码",
        "state": "州"
      },
      "tax": {
        "title": "税号"
      }
    }
  },
  "checkouts": {
    "header": "结账",
    "payment_method": "选择支付方式",
    "stripe_card": "信用卡（Stripe）",
    "paypal": "PayPal",
    "address": {
      "new": "输入新账单地址",
      "existing": "使用已有地址"
    },
    "pay_stripe": "确认并付款",
    "terms": "确认订阅，即表示您同意 Linguise 根据条款向您收取后续付款。您可随时取消订阅。",
    "coupon": {
      "title": "有优惠券？",
      "placeholder": "在此输入您的优惠券",
      "apply": "应用",
      "percent": "优惠 {{0}}%"
    },
    "add_new": "新增",
    "use_existing": "使用已有付款方式",
    "recurring": {
      "month_single": "按月计费",
      "month_many": "每 {{count}} 个月计费",
      "year_single": "按年计费",
      "year_many": "每 {{count}} 年计费",
      "day_single": "按日计费",
      "day_many": "每 {{count}} 天计费",
      "week_single": "按周计费",
      "week_many": "每 {{count}} 周计费"
    },
    "add_new_no_stripe": "添加新卡片",
    "summary": {
      "title": "概览",
      "subtotal": "小计",
      "total": "总计"
    }
  },
  "dashboard": {
    "main": {
      "title": "仪表板"
    },
    "statistics": {
      "main_title": "过去30天统计",
      "characters": "已翻译字符数",
      "words": "已翻译词数",
      "bandwidth": "输入带宽",
      "request": "请求数",
      "page_views": "各语言页面浏览量（过去30天）",
      "multilingual_views": "多语言页面浏览量（过去30天）",
      "most_page_viewed": "20 个最常被浏览的页面（过去30天）",
      "no_data_yet": "暂无数据",
      "th_language": "语言",
      "th_page_views": "页面浏览量",
      "real_visitors": "真实访客",
      "crawler": "网络爬虫"
    },
    "planHints": {
      "subscribeButton": "订阅",
      "upgradeButton": "升级",
      "usedWords": "您目前使用了 {words_used} 词",
      "noPlan": "此域名尚未激活套餐。立即订阅计划，开始翻译您的网站",
      "noPlanShopify": "此域名尚未激活套餐。请在您的 Shopify 后台订阅计划，开始翻译您的网站",
      "trialUsage": "您目前使用了 {words_used} 词，试用计划包含 {words_allowed} 词。",
      "trialEnds": "首月试用期截止至 {trial_ends}。",
      "subscribeMessage": "试用期结束前订阅，以保持网站持续翻译",
      "subscribeMessageShopify": "请在 Shopify 后台中订阅，以保持网站持续翻译",
      "trialReachedLimit": "您已达到试用期的词数上限。\n订阅我们的计划，以继续翻译您的网站。",
      "paidUsage": "您已使用 {words_used} / {words_allowed} 翻译词数。",
      "paidReachedLimit": "您已用满当前计划的翻译词数上限。\n升级计划，以继续翻译网站内容。",
      "trialOfferedUsage": "您目前使用了 {words_used} 词，试用计划包含 {words_allowed} 词（含赠送的 {free_words} 词）。",
      "paidOfferedUsage": "您已使用 {words_used} / {words_allowed} 翻译词数（含赠送的 {free_words} 词）。",
      "noPlanExtra": "请注意，未激活的域名及其数据会被定期自动删除。",
      "planRecommended": "根据当前翻译量，推荐的计划为：",
      "planMaximumWords": "{{words}} 词",
      "notHaveTranslatedWords": "您尚未进行任何翻译"
    },
    "translationSetup": {
      "kicker": "子域名设置",
      "title": "检查翻译设置",
      "description": "检查 DNS、已翻译主机、原始网站访问权限和账户限制。",
      "starting": "正在检查...",
      "button": "检查设置",
      "viewLatest": "查看最新结果",
      "viewCurrent": "查看当前检查",
      "runAgain": "重新检查",
      "viewDetails": "查看详情",
      "hideDetails": "隐藏详情",
      "error": "无法检查设置",
      "allPassed": "所有检查均已通过",
      "setupNeedsAttention": "设置需要处理",
      "setupNeedsAttentionDescription": "一项或多项检查失败。请查看下方项目或联系 Linguise 支持团队。",
      "lastChecked": "上次检查时间：{{time}}",
      "domainOwnership": "域名所有权",
      "domainOwnershipDescription": "已找到验证记录",
      "domainOwnershipFailure": "无法验证所有权 DNS 记录。",
      "translatedHosts": "已翻译主机",
      "translatedHostsDescription": "已检查 {{count}} 个语言主机",
      "translatedHostsFailure": "一个或多个语言 CNAME 记录不正确。",
      "subdomainPage": "子域名页面",
      "subdomainPageDescription": "{{count}} 个已翻译页面接受 HTTPS",
      "subdomainPageFailure": "打开一个或多个已翻译页面时 TLS 连接失败。",
      "originalSite": "原始网站",
      "originalSiteDescription": "原始网站的 DNS、TLS 和响应检查",
      "originalSiteFailure": "原始网站的 DNS、TLS 或响应检查失败。",
      "documentationAdvice": {
        "dns": "检查 DNS 设置",
        "tls": "检查 HTTPS 设置",
        "origin": "检查原始网站设置",
        "diagnostic": "查看故障排除步骤"
      },
      "evidence": {
        "originDns": "原始 DNS",
        "originTls": "原始 TLS",
        "originHttp": "原始响应",
        "observedTargets": "检测到的目标",
        "recordCount": "找到的记录",
        "addressCount": "找到的地址",
        "statusCode": "HTTP 状态",
        "redirect": "重定向",
        "expiresAt": "证书到期时间",
        "raw": "{{key}}",
        "noValue": "无值"
      },
      "checkerError": "部分检查无法完成。",
      "coreLocation": "从 {{location}} 检查",
      "status": {
        "queued": "排队中",
        "running": "运行中",
        "completed": "已完成",
        "failed": "失败",
        "passed": "通过",
        "warning": "警告",
        "unknown": "未知",
        "skipped": "已跳过",
        "not_applicable": "不适用"
      }
    },
    "throttling": {
      "title": "翻译限制",
      "description": "临时使用限制",
      "unavailable": "暂时无法获取翻译限制",
      "window": "{{used}} / {{max}} 个词",
      "resetsIn": "将在 {{time}} 后重置",
      "throttled": "翻译已暂时暂停",
      "throttledDescription": "已达到临时使用限制。此时间段重置后将恢复翻译。"
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "步骤 {{step}} / {{total}}",
      "doneLabel": "完成，开始翻译！",
      "finish": {
        "title": "",
        "description": "这是将用于您网站的 API 密钥"
      },
      "instructions": "安装说明",
      "domainSetting": "域名设置",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP 脚本",
        "wizardWordpressStep1": "1. 安装",
        "wizardWordpressStep2": "\n 2. 在插件设置中复制并填写您的 API 密钥\n",
        "wizardWordpressStep3": "3. 可以开始翻译\n\n",
        "wizardWordpressStep4": "如需详细说明，请查看我们的文档：",
        "wizardJoomlaStep1": "1. Joomla 安装包链接：",
        "wizardJoomlaStep2": "\n2. 在扩展配置设置中复制并填写您的 API 密钥",
        "wizardJoomlaStep3": "3. 在模块配置中设置您要显示的语言，并在需要的位置插入模块。",
        "wizardJoomlaStep4": "\n4. 您已准备好进行翻译\n\n",
        "wizardPhpStep1": "1. 在此处下载我们的 php 脚本：",
        "wizardPhpStep2": "\n2. 按照此处文档页面中的安装说明操作：",
        "wizardPhpStep3": "\n3. 将模块添加到您的页面。",
        "wizardPhpStep4": "\n复制以下代码并将其添加到 html 页面的头部，它将自动显示切换器模块\n",
        "dispatchStep1": "我们已成功将所需数据发送至 Linguise 插件，您现在可以关闭以下窗口。",
        "dispatchStep2": "如果您关闭此窗口时令牌丢失，请复制以下令牌：",
        "dispatchStep3": "您也可以复制此代码段以自动启用我们的旗帜切换器",
        "wizardOtherStep1": "请按照以下说明在您的域名上安装 Linguise。\n",
        "wizardOtherStep2": "复制以下代码并将其添加到 html 页面的头部，它将自动显示切换器模块。\n"
      },
      "trialAlreadyUsed": "似乎您已使用过免费试用版，因此需要获取翻译配额\n请订阅套餐，或联系我们以延长试用。",
      "usefulLinks": "入门实用链接",
      "linkDocumentation": "文档",
      "linkExtensionDl": "扩展下载",
      "linkSubscribe": "立即订阅套餐",
      "linkDashboard": "前往控制台",
      "exclusion": {
        "title": "公司和产品名称",
        "description": ""
      },
      "finishButton": "完成设置",
      "subdomains": "子域名",
      "subdomain_setup": "设置域名",
      "subdomain_auto_setup": "自动连接 DNS",
      "subdomain_manual_setup": "手动添加 DNS 记录",
      "subdomain_skip": "稍后操作",
      "auto_subdomains_info": "您的站点构建器 CMS 需要 DNS 配置，以便按子域名设置语言（例如 es.domain.com）。",
      "auto_subdomains_info_2": "您可以使用 Entri 自动完成此操作。只需点击“自动连接 DNS”按钮，即可开始连接到您的 DNS 管理器并通过 Entri 添加记录。",
      "auto_subdomains_info_manual": "或者，您可以点击“手动添加 DNS 记录”按钮，手动配置域名。",
      "breadcrumbs": {
        "step1": "第一步：域名、内容管理系统和语言",
        "step2": "步骤 2：语言 DNS",
        "step3": "步骤 {{step}}：安装说明"
      }
    },
    "form": {
      "urls": {
        "dash": "连字符 -",
        "underscore": "下划线 _",
        "title": "翻译 URL",
        "description": "是否在所有页面中翻译",
        "char_description": "用于替换 URL 中未授权字符的字符",
        "advertisement_title": "⚠ 您已设置了很多语言。\n",
        "advertisement": "我们通常建议一开始先用少量语言翻译网站。这样您能大致了解网站有多少单词。对 SEO 也更有利，因为 Google 爬虫在页面较少时会更快抓取所有页面。一周后您可以再添加一些语言，依此类推。"
      },
      "url": {
        "title": "网址",
        "description": "填写您的主域名 URL，以 http:// 或 https:// 开头",
        "placeholder": "域名 URL",
        "advertisement_http": {
          "title": "您未使用 https 协议",
          "description": "请确认您的域名实际未使用 https 协议，如今这已是推荐做法。"
        },
        "advertisement_www": {
          "title": "您的子域名不是 www",
          "description": "大多数情况下默认子域名为 www（如 https://www.mydomain.com）。可能并非您的情况，但请再次确认您要添加的域名是否正确。"
        },
        "invalid_url": {
          "line1": "我们无法找到您的域名。请确认您的域名可通过互联网公开访问，且未重定向到其他位置。",
          "line2": "如果您确定域名可访问，可以跳过域名验证并再次点击“下一步”按钮",
          "contact": "如有任何问题，您可联系我们：",
          "force": "跳过域名验证"
        },
        "invalid_subdomain_url": "此网址不被允许。子域名必须采用以下格式：https://www.domain.tld 或 https://domain.tld（不带子目录）。"
      },
      "account": {
        "title": "账户",
        "description": "选择要分配此域名的账户",
        "placeholder": "选择账户…",
        "feedback": "您必须选择一个账户"
      },
      "platform": {
        "title": "平台",
        "description": "请按 CMS 名称选择您的网站平台",
        "learn": "了解如何选择",
        "placeholder": "按 CMS 名称搜索平台…",
        "info": {
          "title": "⚠ 此平台最近新增。\n",
          "desc": "Linguise 支持此网站构建器平台，尽管它是最近新增的。如遇到任何问题，请直接使用支持邮箱联系我们："
        },
        "description_read_only": "您的网站所使用的平台",
        "feedback": "您必须选择一个平台"
      },
      "language": {
        "title": "语言",
        "description": "选择您网站的基础语言",
        "placeholder": "选择语言…",
        "feedback": "您必须选择一种语言",
        "description_read_only": "您网站的基础语言"
      },
      "token": {
        "title": "API 密钥",
        "description": "这是要复制到您网站的 API 密钥",
        "copy": "复制到剪贴板",
        "reset": "重置 API 密钥",
        "reset_confirm": "请确认重置 API 密钥"
      },
      "languages": {
        "title": "翻译语言",
        "description": "选择您希望网站可翻译成的语言",
        "placeholder": "选择语言…",
        "feedback": "您必须选择一种语言"
      },
      "defaultRules": {
        "title": "默认规则",
        "description": "我们已定义一组必须使用的规则，以增强翻译并避免翻译不需要的内容（如 WordPress 后台）。\n您可稍后删除或编辑这些规则（如需）。"
      },
      "disallow_deletion": "无法删除包含有效订阅的域名",
      "delete_confirm": "请确认删除域名",
      "delete": "删除域名",
      "dynamic": {
        "title": "翻译动态内容",
        "description": "由 JavaScript 和 AJAX 请求生成的动态内容将被翻译（此选项会增加翻译使用量）"
      },
      "partial_translations": {
        "title": "允许部分翻译",
        "description": "如果您的账户已达到翻译配额，但页面仍需翻译，Linguise 可以继续显示已翻译的内容。\n然而，页面的某些部分将保持未翻译状态，直到您升级配额。\n\n少量未翻译内容通常不会影响 SEO，但允许过多未翻译内容可能会对用户体验产生负面影响。\n为解决此问题，您可以设置页面允许的未翻译内容百分比阈值。如果未翻译内容超过此阈值，用户将自动重定向到页面的原始语言版本。",
        "never": "从不"
      },
      "translate_error_pages": {
        "title": "翻译错误页面",
        "description": "Linguise 可以翻译所有错误页面，但如果您的错误页面包含动态内容（如 IP 地址或请求 ID），应避免翻译这些页面。",
        "not_found_page": {
          "title": "翻译 404 页面"
        },
        "error_page": {
          "title": "翻译其他错误页面"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "发现现有域名",
          "description": "为此用户找到了现有域名，您是否想使用它？"
        }
      },
      "search_tl": {
        "title": "搜索翻译",
        "description": "为您的网站平台启用搜索翻译（实验性功能，此选项会增加翻译使用量）"
      },
      "shopify_promo": {
        "info": "好消息！我们现在推出了 Shopify 原生应用，您可以从 Shopify 应用商店安装。",
        "hyperlink": "点击这里，通过应用程序安装 Linguise。",
        "next_btn": "前往 Shopify 商店安装该应用",
        "info_legacy": "好消息！我们现在推出了 Shopify 原生应用，您可以从 Shopify 应用商店安装。",
        "description_legacy": "请选择“Shopify”平台，而不是“Shopify Legacy”。"
      },
      "wix_promo": {
        "info": "好消息！我们现在推出了 Wix 原生应用，您可以从 Wix 应用市场安装。",
        "hyperlink": "点击这里，通过应用程序安装 Linguise。",
        "next_btn": "前往 Wix 应用市场安装该应用",
        "info_legacy": "好消息！我们现在推出了 Wix 原生应用，您可以从 Wix 应用市场安装。",
        "description_legacy": "请选择“Wix”平台，而不是“Wix Legacy”。"
      },
      "ai_disallow_deletion": "当 AI 配额仍然可用时，您无法删除此域。\n\n如果您想删除此域名，请联系我们的支持团队：",
      "language_removal": {
        "card": {
          "title": "删除已移除语言的翻译",
          "description": "这些语言已从您的网站中移除，但其已保存的翻译仍计入用量。删除这些翻译即可返还相应词数。",
          "button": "删除翻译"
        },
        "hint": "已用词数将返还到您的用量中。每个网站每 {{days}} 天可操作一次。",
        "modal": {
          "title": "删除翻译？",
          "intro": "以下翻译将被永久删除：",
          "warning": "此操作无法撤销。已用词数将返还到您的用量中，这可能需要几分钟。",
          "limit": "每个网站每 {{days}} 天可操作一次。",
          "confirm": "删除翻译"
        },
        "scheduled": "正在删除翻译，您的用量很快会更新。",
        "cooldown": "此网站的翻译最近已删除。您可以在 {{date}} 再次删除。",
        "latest_completed": {
          "title": "最近一次已完成的删除",
          "description": "查看已删除的语言以及返还到用量中的词数。",
          "languages": "已删除的语言",
          "words_returned": "返还到用量中的词数：{{words}}",
          "completed_at": "完成时间：{{date}}"
        },
        "status": {
          "recent_title": "最近的翻译删除",
          "recent_description": "跟踪最近一次删除，并查看何时可以再次删除。",
          "progress_title": "删除进度",
          "loading": "正在检查删除进度...",
          "unavailable": "无法加载删除进度。请刷新页面后重试。",
          "label": "状态",
          "pending": "排队中",
          "processing": "进行中",
          "completed": "已完成",
          "failed": "失败",
          "unknown": "状态不可用",
          "percent": "已完成 {{percent}}%",
          "current_stage": "当前步骤：{{stage}}",
          "processed": "已处理 {{processed}} 条记录",
          "processed_total": "已处理 {{total}} 条记录中的 {{processed}} 条",
          "requested_at": "请求时间：{{date}}",
          "started_at": "开始时间：{{date}}",
          "completed_at": "完成时间：{{date}}",
          "cooldown_period": "每个网站每 {{days}} 天可操作一次。",
          "cooldown_blocked": "暂时无法开始另一次删除。",
          "stage": {
            "queued": "等待开始",
            "processing": "进行中",
            "refund_summary": "正在计算返还词数",
            "search_translations": "正在删除搜索翻译",
            "url_translations": "正在删除 URL 翻译",
            "translations": "正在删除翻译",
            "completed": "已完成",
            "failed": "失败",
            "unknown": "进行中"
          }
        },
        "forbidden": "您没有删除翻译的权限。"
      }
    },
    "main": {
      "edit": "编辑域名",
      "add": "添加域名",
      "wizard": "欢迎！新域名创建向导",
      "common": "域名"
    },
    "notice": {
      "broken_card": "我们无法使用当前付款方式为 {{url}} 续订套餐，请更新您的付款卡",
      "quota_reached": "{{url}} 的翻译配额已用完，请升级以恢复网站翻译",
      "ai_no_subscription": "{{url}} 的 AI 翻译需要有效订阅或有效试用。如缺少其一，翻译将停止，请升级以继续",
      "important": "重要",
      "quota_reached_button": "立即升级套餐",
      "broken_card_button": "更新付款卡",
      "ai_no_subscription_button": "立即升级套餐",
      "quota_warning": "您对 {{url}} 的翻译配额已达到 {{throttling_used_percent}}%，这将在 {{ttl}} 重置。",
      "locked": "域 {{url}} 目前已锁定迁移，您仍然可以访问您的网站，但无法编辑或添加新翻译！"
    },
    "subdomains": {
      "config_ok": "子域名 DNS 已正确配置。",
      "config_invalid": "子域名 DNS 需要额外配置才能正常工作。",
      "config_check": "正在检查子域名 DNS 配置，请稍候...",
      "entri_timeout": "Entri 报告您的子域名 DNS 传播过程已超时，您需要重试或手动完成。",
      "entri_process": "您的 DNS 已通过 Entri 添加，通常需要 10–30 分钟完成传播（应用所有语言子域名，如 es.domain.com）。若 24 小时后 DNS 验证仍未完成，请联系支持团队：support@linguise.com",
      "entri_ok": "DNS 传播中！等待传播完成...",
      "infos": "您必须将这些 DNS 条目添加到您的 DNS 域记录中才能激活翻译。完成后，单击“检查”按钮。DNS 记录可能需要一些时间才能生效，因此您可能需要在几分钟或几小时后返回查看。",
      "check": "检查 DNS 配置"
    },
    "subscription": {
      "next_payment_amount": "即将扣款",
      "next_payment_date": "下次付款日期",
      "invoice": {
        "header": "发票记录",
        "date": "日期",
        "amount_due": "金额",
        "status": "状态",
        "actions": "操作",
        "description": "交易可用后，可在此处查看。",
        "status_text": {
          "draft": "草稿",
          "failed": "失败",
          "open": "待付",
          "paid": "已付",
          "retrying": "重试中",
          "uncollectible": "无法收回",
          "void": "作废"
        },
        "view": "查看",
        "empty": "未找到该订阅的近期发票",
        "retry_payment": "重试"
      },
      "next_cancellation": "取消日期",
      "cancel": "取消订阅",
      "change_plan": "更改套餐",
      "change": "更改",
      "suspend": "暂停付款",
      "resume": "恢复订阅",
      "back": "返回",
      "save": "保存",
      "confirm_resume": "确定要恢复此订阅吗？",
      "confirm_cancel": "确定要取消此订阅吗？",
      "confirm_header": "确定吗？",
      "missing_status": "缺少此订阅",
      "not_found": "未找到此域名的订阅",
      "confirm_manual_retry": "确定要重试此付款吗？",
      "no_payment_method": "未知",
      "remove_billing": "移除",
      "shopify_maneged": "该订阅由 Shopify 管理，请在 Shopify 后台操作。",
      "unknown_plan": "未知计划"
    }
  },
  "domain_listing": {
    "add": "添加网站",
    "select": "选择域名"
  },
  "editable": {
    "number": "编号 {{id}}"
  },
  "footer": {
    "about": "关于",
    "support": "支持"
  },
  "frontendEditor": {
    "main": "实时编辑器",
    "description": "实时编辑器可直接在网站上编辑译文。",
    "button": "打开实时编辑器",
    "language_selection": "选择翻译语言",
    "video_label": "学习如何使用实时编辑器"
  },
  "general": {
    "403": {
      "tab_title": "哎呀 - 403 错误",
      "title": "访问被拒绝",
      "message": "您似乎无权访问请求的页面。",
      "home": "返回首页"
    },
    "404": {
      "tab_title": "哎呀 - 404 错误",
      "title": "页面未找到",
      "message": "您可能走错路了，别担心… 人人都会遇到。这里有个小提示，帮您回到正轨。",
      "home": "返回首页"
    },
    "500": {
      "tab_title": "500 错误",
      "title": "内部服务器错误",
      "message": "试试刷新页面？或联系我们",
      "home": "返回首页"
    },
    "fields": {
      "alert": "部分字段无效，请修正无效字段。",
      "invalid": "此字段无效",
      "phone_re": "手机号码无效",
      "phone_invalid": "手机号码无效",
      "email": "电子邮件字段无效"
    },
    "table": {
      "no_data": "暂无数据..."
    },
    "saving": "保存中...",
    "save": "保存",
    "save_and_quit": "保存并退出",
    "invite": "邀请",
    "cancel": "取消",
    "yes": "是",
    "no": "否",
    "nextStep": "下一步",
    "loading": "应用加载中，请稍候",
    "goback": "返回",
    "manage": "管理",
    "delete": "删除",
    "deleting": "删除中...",
    "confirm": "确认",
    "unknown": "未知",
    "hide": "隐藏",
    "show": "展示",
    "on": "在",
    "off": "离开",
    "default": "默认"
  },
  "home": {
    "header": "首页",
    "manage": "管理订阅",
    "canceled": "已计划取消",
    "activate_now": "立即激活",
    "activate_plan_now": "立即订阅",
    "upgrade_plan_now": "立即升级套餐",
    "trial_message_part_1": "您当前为试用套餐，",
    "trial_message_part_2": "可随时激活会员。",
    "add": "添加域名",
    "table": {
      "title": "域名",
      "description": "您的域名列表，点击域名管理译文"
    },
    "domains": {
      "empty": "您尚无域名"
    },
    "accountsList": {
      "title": "账户",
      "add": "添加新账户",
      "name": "账户名称"
    },
    "update_credit_card": "更新信用卡详情",
    "cancelling_subs": "将于{{0}}取消",
    "resume_subscription": "恢复订阅",
    "shopify_managed": "由Shopify管理",
    "trial_ends_at": "结束于 {{0}}",
    "free_trial": "免费试用",
    "no_subs": "没有活跃的订阅"
  },
  "invoices": {
    "title": "发票",
    "list": {
      "title": "发票列表"
    },
    "table": {
      "customer": "客户",
      "domain": "域名",
      "amountPaid": "已付金额",
      "status": "状态",
      "date": "日期",
      "invoice": "发票",
      "pay": "支付发票",
      "actions": "操作",
      "deleted_domain": "域名已删除",
      "plan_name": "套餐",
      "action": "操作"
    },
    "listPending": {
      "title": "待处理发票列表"
    }
  },
  "language_settings": {
    "display": "语言列表显示",
    "position": "位置",
    "display_help_text": "显示国旗和/或语言名称。语言切换器的默认位置可以是内容的任意位置，也可固定于滚动时静止或移动的位置",
    "side_by_side": "并排",
    "dropdown": "下拉菜单",
    "popup": "弹出窗口",
    "flag": "旗帜",
    "lang_name": "语言名称",
    "lang_short_name": "简称",
    "positions": {
      "in_place": "原位",
      "top_left": "左上角",
      "top_left_no_scroll": "左上角（不随滚动）",
      "top_right": "右上角",
      "top_right_no_scroll": "右上角（不随滚动）",
      "bottom_left": "左下角",
      "bottom_left_no_scroll": "左下角（不随滚动）",
      "bottom_right": "右下角",
      "bottom_right_no_scroll": "右下角（不随滚动）"
    },
    "lang_names_display": {
      "title": "语言名称显示",
      "help_text": "在语言切换器中，以英文或各语言本地名称显示，如法语显示为Français",
      "english": "英文",
      "native_languages": "本地语言"
    },
    "flag_shape": {
      "title": "旗帜样式",
      "help_text": "使用圆形或矩形SVG旗帜图标",
      "round": "圆形",
      "rectangular": "矩形"
    },
    "english_flag_type": {
      "title": "英语旗帜类型",
      "help_text": "为英语使用英国或美国国旗",
      "usa": "美国国旗",
      "great_britain": "英国国旗"
    },
    "german_flag_type": {
      "title": "德语旗帜类型",
      "help_text": "为德语使用奥地利或德国国旗",
      "german": "德国国旗",
      "austria": "奥地利国旗"
    },
    "spain_flag_type": {
      "title": "西班牙语旗帜类型",
      "help_text": "为西班牙语使用墨西哥或西班牙国旗",
      "spanish": "西班牙国旗",
      "mexico": "墨西哥国旗",
      "peruvian": "秘鲁国旗"
    },
    "portugal_flag_type": {
      "title": "葡萄牙语旗帜类型",
      "help_text": "为葡萄牙语使用葡萄牙或巴西国旗",
      "portugal": "葡萄牙国旗",
      "brazil": "巴西国旗"
    },
    "taiwanese_flag_type": {
      "title": "台湾语旗帜类型",
      "help_text": "为台湾语使用台湾或中国国旗",
      "taiwanese": "台湾旗帜",
      "chinese": "中国国旗"
    },
    "flag_border_radius": {
      "title": "旗帜圆角(px)",
      "help_text": "若使用矩形旗帜，可设置圆角像素值"
    },
    "flag_width": {
      "title": "旗帜大小(px)",
      "help_text": "选择旗帜大小（像素）。因使用SVG图片，不会增加图片体积"
    },
    "lang_color": {
      "color_title": "语言名称颜色",
      "color_help_text": "为语言名称选择默认文字颜色",
      "hover_color_title": "语言名称悬停颜色",
      "hover_color_help_text": "为语言名称鼠标悬停文字颜色",
      "color_popup_title": "弹窗语言颜色",
      "color_popup_help_text": "弹窗或下拉区域中语言标题颜色",
      "hover_color_popup_title": "弹窗语言悬停颜色",
      "hover_color_popup_help_text": "弹窗或下拉区域中语言标题的鼠标悬停文字颜色"
    },
    "flag_box_shadow": {
      "shadow_title": "旗帜阴影",
      "shadow_help_text": "语言旗帜的颜色与阴影大小",
      "hover_shadow_title": "旗帜悬停阴影",
      "hover_shadow_help_text": "语言旗帜鼠标悬停时的颜色与阴影大小",
      "shadow_h_offset": "阴影水平偏移(px)",
      "shadow_v_offset": "阴影垂直偏移(px)",
      "shadow_blur": "阴影模糊(px)",
      "shadow_spread": "阴影扩散(px)",
      "shadow_color": "阴影颜色"
    },
    "order": "语言顺序",
    "language_order_help": "语言切换器中的显示顺序，可拖动重新排序",
    "order_reset": "重置顺序",
    "language_order_dragdrop": "可拖动重新排序",
    "popup_lang_name": "弹窗语言名称",
    "preview": "语言预览"
  },
  "link": {
    "form": {
      "original": {
        "title": "原始来源",
        "description": "添加原始链接URL，并按语言替换下方对应语言",
        "srcset_description": "您正在编辑图片URL。若使用srcset或不了解，请阅读文档",
        "link": "链接",
        "match_link": "匹配模式",
        "match_exact": "精确",
        "match_wildcard": "通配符",
        "match_regex": "正则表达式"
      },
      "alternative_languages": {
        "title": "待替换的链接",
        "description": "按语言替换您页面上所有媒体链接和外部链接…",
        "link": "待替换的链接"
      },
      "error": {
        "atLeastOne": "请至少添加一个翻译。",
        "url": "URL 无效",
        "extension": "链接必须包含扩展名，但不能是 .html 或 .php。且链接不得包含语言路径，例如 \"/fr\"",
        "regex": "正则表达式无效",
        "wildcard": "通配符链接的协议无效"
      }
    },
    "main": {
      "parent": "链接",
      "edit": "编辑链接"
    }
  },
  "links": {
    "title": "媒体与外部链接管理",
    "description": "列出并编辑您网站的媒体链接或外部链接。",
    "add": "添加链接",
    "delete": "删除链接",
    "table": {
      "original": "原链接",
      "language": "语言",
      "translation": "翻译",
      "action": "操作",
      "delete_confirm": "请确认删除链接"
    }
  },
  "members": {
    "header": "成员",
    "invite": "邀请新成员",
    "modal": {
      "inviteHeader": "邀请新成员",
      "editHeader": "编辑成员",
      "detachHeader": "移除成员",
      "detachBody": "您确定要将该成员从此账户移除吗？",
      "selfDetachBody": "您确定要将自己从此账户管理中移除吗？此后您将无法访问与该账户相关的任何数据。"
    },
    "table": {
      "title": "成员列表",
      "description": "成员角色与域名权限",
      "name": "姓名",
      "email": "邮箱",
      "websites": "网站",
      "languages": "语言",
      "role": "角色",
      "status": "状态",
      "resendInvite": "重新发送",
      "inviteSent": "邀请已发送",
      "actions": "操作",
      "edit": "编辑",
      "detach": "移除",
      "empty": "您还没有任何成员",
      "all_website": "所有网站和语言",
      "roles": {
        "admin": "管理员",
        "manager": "经理",
        "translator": "翻译员"
      },
      "statuses": {
        "pending": "待定",
        "accepted": "已接受",
        "declined": "已拒绝"
      }
    },
    "errors": {
      "role": "必须选择一个角色",
      "domains": "必须为所选角色至少选择 1 个网站",
      "languages": "必须为所选网站至少选择 1 种语言"
    },
    "inviteSent": "您的邀请已成功发送"
  },
  "pagination": {
    "showing": "显示 {{limit}} 条结果，共 {{total}} 条",
    "showing_only_count": "显示 {{limit}} 条结果"
  },
  "payments_method": {
    "header": "支付方式",
    "table": {
      "title": "支付方式列表",
      "description": "关联到您账户的支付方式",
      "default": "默认",
      "action_edit_remove": "编辑或移除",
      "action_remove": "移除",
      "action_default": "设为默认",
      "action_fallback": "设为备用",
      "expires": "有效期",
      "add_new_card": "添加支付方式",
      "action_fallback_remove": "移出备用",
      "fallback": "备用",
      "action_edit": "编辑",
      "action_delete": "删除",
      "action_default_remove": "取消默认",
      "domain_count@@one": "被 {{count}} 个域名使用",
      "domain_count@@other": "被 {{count}} 个域名使用"
    },
    "paypal_bind": {
      "button": "连接 PayPal 账户",
      "button_load": "连接中…",
      "disconnected": "未连接",
      "success": "您的 PayPal 账户已连接，下次账单将立减 $5！",
      "success_no_promo": "您的 PayPal 账户已连接",
      "error": "发生错误",
      "success_header": "成功"
    },
    "card_add": {
      "header": "添加新卡",
      "success": "已成功向 Linguise 绑定新卡！",
      "terms": "通过提供您的卡片信息，您授权 Linguise 根据服务条款从您的卡片中扣款。"
    },
    "card_detail": {
      "header": "卡片信息",
      "delete": {
        "error": "无法删除此支付方式，因其存在有效订阅！"
      }
    },
    "subscriptions": {
      "table": {
        "description": "此支付方式上的订阅",
        "header_domain": "域名",
        "header_plan": "套餐",
        "header_status": "状态",
        "header_actions": "操作",
        "cancelling": "将于 {{0}} 取消",
        "next_payment": "下次付款：{{0}}",
        "action_renew": "续费",
        "no_subs_header": "暂无订阅",
        "no_subs_desc": "一旦此卡产生订阅，所有信息将显示于此",
        "action_manage": "管理"
      },
      "status": {
        "active": "有效",
        "canceled": "已取消",
        "incomplete": "未付款",
        "incomplete_expired": "未付款（已过期）",
        "missing": "错误",
        "past_due": "逾期",
        "trialing": "试用中",
        "unpaid": "未付款"
      }
    },
    "delete_confirm_body": "您确定要删除此支付方式吗？此操作无法撤销！",
    "delete_confirm_header": "删除支付方式？",
    "card_edit": {
      "header": "编辑卡片",
      "billing_header": "账单信息",
      "address_error": "地址不能为空！",
      "card_number": "卡号",
      "card_expiry": "有效期",
      "expiry_error_month": "提供的月份无效",
      "expiry_error_year": "提供的年份无效",
      "expiry_error_expired": "您的银行卡已过期。",
      "card_header": "银行卡信息",
      "expiry_error_empty": "此字段为必填项！"
    }
  },
  "plans": {
    "per": "每",
    "wordsTranslated": "已翻译词数",
    "current": "当前",
    "archived": "已归档",
    "day": "天",
    "week": "周",
    "month": "月",
    "year": "年",
    "activate": "激活",
    "cancel": "取消",
    "change": "更改",
    "upgrade": "升级",
    "downgrade": "降级",
    "resume": "恢复",
    "notEnoughWords": "词数不足",
    "yearIntervalOnly": "无法从年付方案切换",
    "subsCanceled": "另一个订阅取消操作正在进行中",
    "wordsUnlimited": "无限词数",
    "tabs": {
      "day": "日价",
      "week": "周价",
      "month": "月价",
      "year": "年价",
      "sub_texts": {
        "day": "每天固定价格",
        "week": "每周固定价格",
        "month": "每月固定价格",
        "year": "免费1个月，每年收一次费"
      }
    },
    "details": {
      "new_languages": "随时添加新语言",
      "one_month_trial": "每个新网站都可享受一个月的免费试用",
      "multi_content_indexed": "100%多语言内容被收录",
      "translate_new_content": "即时翻译新内容",
      "free_installation": "免费安装与配置",
      "compared_monthly_plan": "与月付方案相比免费1个月",
      "risk_free_recurring": "续费失败仍无任何风险",
      "unlimited_languages": "无限语言与页面浏览量",
      "high_server_resources": "高服务器资源",
      "billed": {
        "day": "按天计费",
        "week": "按周计费",
        "month": "按月计费",
        "year": "按年计费"
      },
      "request_max_size": "请求最大{{0}}大小"
    },
    "frequent_question": {
      "title": "常见问题",
      "questions": {
        "trial": {
          "question": "我可以为新网站域名使用试用吗？",
          "answer": "可以，我们为每个添加的新网站域名提供30天免费试用，您可以在新网站上充分测试翻译服务。"
        },
        "seo": {
          "question": "SEO多久会改善？",
          "answer": "内容及多语言内容需要一段时间才能被充分收录并获得良好排名。根据您网站的流量与规模，大约需3到6周。"
        },
        "quota": {
          "question": "人工翻译计不计入词数配额？",
          "answer": "不计入，词数配额仅针对自动机器翻译。翻译人员可以无限量手动编辑自动翻译。"
        }
      }
    },
    "best_offer": "超值优惠",
    "period": {
      "days@@one": "天",
      "days@@other": "{{count}}天",
      "hours@@one": "小时",
      "hours@@other": "{{count}}小时",
      "minutes@@one": "分钟",
      "minutes@@other": "{{count}}分钟",
      "seconds@@one": "秒",
      "seconds@@other": "{{count}}秒"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "每{{period}}{{words}}词"
  },
  "profile": {
    "welcome": "欢迎！",
    "account": "我的账户",
    "subscriptions": "订阅",
    "logout": "登出"
  },
  "register": {
    "errors": {
      "password": "至少8个字符，任意字符"
    }
  },
  "route": {
    "dashboard": "仪表板",
    "rules": "规则",
    "translations": "译文",
    "search_translations": "搜索查询",
    "urls_translations": "网址翻译",
    "links": "媒体及外链",
    "online_editor": "实时编辑器",
    "settings": "设置",
    "domain": {
      "finish": "设置",
      "preconfig": "设置"
    },
    "home": "首页",
    "domain_list": "域名列表",
    "members": "成员",
    "invoices": "发票",
    "billing": "账单信息",
    "language_display": "语言图标显示",
    "payment_methods": "支付方式",
    "ai_translation": "AI翻译",
    "ai_translation_settings": "设置",
    "ai_translation_pricing": "定价"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "需要忽略的文本",
        "add": "添加",
        "title": "需要忽略的文本",
        "description": "添加一个或多个需要忽略的文本",
        "ignore_case": "忽略大小写"
      },
      "html_content": {
        "title": "应用于HTML内容",
        "description": "对整个内容应用规则，或指定CSS选择器",
        "all_page": "整页",
        "css_selector": "CSS选择器",
        "label": "CSS选择器",
        "placeholder": "选择器应用于",
        "add": "添加新内容"
      },
      "apply_to_urls": {
        "title": "应用到URL",
        "description": "选择要应用规则的具体URL",
        "all_urls": "所有URL",
        "selected_urls": "选定URL",
        "label": "要应用的URL",
        "placeholder": "要应用的URL",
        "original_url": "原始URL",
        "translated_url": "已翻译的URL",
        "wildcard": "通配符",
        "regex": "正则表达式",
        "add": "添加新项",
        "expression": "表达式类型"
      },
      "apply_urls": {
        "title_exclude": "排除URL",
        "title_replace": "替换URL",
        "title_description": "同时将此规则应用于URL的翻译"
      },
      "apply_languages": {
        "title": "应用到语言",
        "description": "选择要应用规则的具体语言",
        "all_languages": "所有语言",
        "selected_languages": "选定语言",
        "placeholder": "选择语言...",
        "feedback": "必须选择一种语言"
      },
      "name": {
        "title": "标题",
        "description": "为方便起见，给规则起个标题",
        "placeholder": "规则名称"
      },
      "type": {
        "title": "类型",
        "description": "选择要添加的规则类型",
        "text_ignore": "忽略文本",
        "text_replace": "替换文本",
        "content_exclusion": "排除内容",
        "url_exclusion": "按URL排除",
        "ignore_inline": "忽略内联",
        "full_description": {
          "text_ignore": "添加规则以避免某些文本被翻译。例如产品名称、品牌名称或其他您不希望翻译的技术元素。",
          "text_replace": "文本替换允许将某些文本替换为您想要的翻译，当翻译忽略上下文时可能很有用。",
          "content_exclusion": "内容排除可帮助您避免翻译页面中的某些内容。\n如果您想完全排除某个页面的翻译（该页面将没有多语言URL且没有翻译内容），请使用“按URL排除”类型",
          "url_exclusion": "页面翻译排除可帮助您设置不希望翻译的页面。",
          "ignore_inline": "避免将某些内容作为内联内容翻译，而是单独翻译每个标签。"
        }
      },
      "text_replace": {
        "title": "要替换的文本",
        "description": "将某些文本替换为您的特定翻译。按语言在整个页面中替换任何文本……",
        "text_to_replace": "要替换的文本",
        "ignore_case": "忽略大小写",
        "text_type": "在翻译中替换",
        "text_type_original": "原文",
        "text_type_translation": "译文",
        "keep_case": "尽量保持大小写",
        "add": "添加新项"
      },
      "content_exclusion": {
        "title": "排除内容",
        "description": "选择一个或多个不会翻译的CSS选择器",
        "label": "CSS选择器",
        "placeholder": "要应用的选择器",
        "add": "添加新项"
      },
      "multilingual_url": {
        "title": "使用多语言URL",
        "description": "如果设置为“是”，URL将不会被翻译，但页面仍将保持多语言并拥有翻译内容",
        "live_example_title": "实时示例",
        "live_example_description": "源URL：https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "生成的URL：https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "生成的URL：https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "将规则应用于静态内容、动态内容或两者",
        "title": "应用到内容",
        "all": "所有内容",
        "static": "静态内容",
        "dynamic": "动态内容"
      },
      "force_apply_urls": {
        "title_description": "强制将此规则应用于所有URL的翻译，包括现有的翻译！",
        "title_replace": "强制替换URL",
        "title_exclude": "强制排除URL",
        "warning": "警告",
        "warning_part1": "将此设置为“是”可能会破坏您网站的URL翻译。",
        "warning_part2": "这可能会暂时或永久生成404页面，请仅在理解后果的情况下继续。",
        "warning_replacement_original": "额外警告：您正在尝试替换原始内容，这可能会影响URL，翻译可能会失败，因为Linguise无法正确找到原始URL"
      }
    },
    "main": {
      "parent": "规则",
      "edit": "编辑规则",
      "add": "新建规则"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "“{{text_ignore}}”将在内容和URL中被忽略",
      "preview_single": "“{{text_ignore}}”将在内容中被忽略",
      "preview_more_with_url": "“{{text_ignore}}”及其他{{count}}个内容将在内容中被忽略",
      "preview_more": "“{{text_ignore}}”及其他{{count}}个内容将在内容中被忽略",
      "other_parameters": "此规则设置了其他参数，点击编辑按钮以获取更多信息"
    },
    "text_replace": {
      "preview_single_with_url": "在内容和URL中，“{{original}}”将被替换为“{{replacement}}”",
      "preview_single": "在内容中，“{{original}}”将被替换为“{{replacement}}”",
      "preview_more_with_url": "在内容和URL中，“{{original}}”将被替换为“{{replacement}}”，还有{{nb}}处",
      "preview_more": "在内容中，“{{original}}”将被替换为“{{replacement}}”，还有{{nb}}处",
      "other_parameters": "此规则设置了其他参数，点击编辑按钮以获取更多信息"
    },
    "content_exclusion": {
      "selectors": "{{nb}}个CSS选择器被排除在翻译之外",
      "other_parameters": "此规则设置了其他参数，点击编辑按钮以获取更多信息"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}}个URL被排除在翻译之外，但仍保留多语言前缀",
      "some": "{{nb}}个URL被完全排除在翻译之外",
      "all_multilingual": "所有URL被排除在翻译之外，但仍保留多语言前缀",
      "all": "所有URL被完全排除在翻译之外",
      "other_parameters": "此规则设置了其他参数，点击编辑按钮以获取更多信息"
    },
    "ignore_inline": {
      "elements": "页面中的所有内联内容将作为块内容翻译",
      "all_elements": "页面中的一些内联内容将作为块内容翻译",
      "other_parameters": "此规则还设置了其他参数，点击编辑按钮了解更多信息。"
    },
    "title": "规则管理",
    "description": "管理整个站点的翻译内容排除和替换",
    "add": "添加新规则",
    "table": {
      "title": "标题",
      "no_data": "暂无规则",
      "type": "类型",
      "preview": "规则预览",
      "action": "操作",
      "delete_confirm": "请确认删除规则",
      "types": {
        "text_ignore": "忽略文本",
        "text_replace": "文本替换",
        "content_exclusion": "内容排除",
        "url_exclusion": "网址排除",
        "ignore_inline": "忽略内联",
        "unknown": "未知规则"
      }
    },
    "apply_on_content": {
      "static": "此规则仅适用于静态内容",
      "dynamic": "此规则仅适用于动态内容"
    }
  },
  "search_translations": {
    "title": "搜索查询管理",
    "description": "列出您通过搜索表单使用的所有网站翻译（从翻译语言到您的域名基础语言）",
    "filter_languages": "按语言筛选…",
    "filter_original": "按原语言文本筛选",
    "filter_translation": "按翻译文本筛选",
    "table": {
      "original": "原文",
      "language": "语言",
      "translation": "译文"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "订阅失败！",
      "title": "订阅失败！",
      "subtitle": "处理订阅时发生错误。",
      "home": "返回首页",
      "generic": "Linguise 端发生未知错误，请联系管理员！"
    },
    "success": {
      "home": "管理域名翻译",
      "message": "我们致力于为您提供最佳的翻译体验。我们的专家团队随时为您提供帮助。点击下方按钮即可开始。",
      "subtitle": "感谢您选择 Linguise 翻译服务",
      "title": "订阅已激活！",
      "tab_title": "感谢您的订阅！"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "订阅已激活！",
      "title": "订阅已激活！",
      "subtitle": "感谢您选择 Linguise 翻译服务",
      "message": "我们致力于为您提供最佳的翻译体验。我们的专家团队随时为您提供帮助。点击下方按钮即可开始。",
      "home": "管理域名翻译"
    },
    "edit": {
      "title": "管理订阅"
    },
    "list": {
      "title": "订阅列表",
      "description": "您的域名订阅列表"
    },
    "table": {
      "domain": "域名",
      "plan": "套餐",
      "status": "状态",
      "card": "卡片",
      "usage": "用量",
      "actions": "操作",
      "payment_method": "付款方式"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} 词",
      "paidOffered": "{{words_used}} / {{words_allowed}} 词\n（含赠送的 {{free_words}} 词）"
    },
    "popup": {
      "dueToday": "今天到期总计",
      "nextPeriod": "从 {{date}} 开始"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "选择账户"
    }
  },
  "translation": {
    "main": {
      "parent": "翻译",
      "edit": "编辑翻译"
    },
    "form": {
      "original": {
        "title": "{{language}} 原文"
      },
      "is_inline": "此翻译来自内联内容。",
      "inline_editor": {
        "count_warning": "内联区域数量与原文不一致（{{current}} / {{expected}}）。",
        "restore_original": "恢复原文",
        "insert_placeholder": "插入占位符",
        "drag": "拖动以重新排列内联区域",
        "area": "内联区域 {{index}}",
        "restore": "恢复缺失的内联区域"
      },
      "translation": {
        "title": "{{language}} 译文",
        "description": "您想要覆盖的译文"
      }
    },
    "copy": {
      "title": "复制到手动翻译",
      "label": "复制到手动"
    },
    "level": {
      "base": {
        "title": "基础翻译",
        "subtitle": "自动 · Linguise Cloud 翻译",
        "empty": "此文本没有基础翻译。",
        "overridden": "已保存您的选择，但由于 AI 翻译设置中的“覆盖手动翻译和选定的翻译”为“是”，将改为显示最新的 AI 增强翻译。关闭该设置即可使用您的选择。"
      },
      "not_generated": "未生成",
      "none": "暂无",
      "ai": {
        "title": "AI 增强翻译",
        "subtitle": "自动 · Linguise AI",
        "empty_title": "此文本尚未生成",
        "empty_description": "Linguise AI 会结合您的页面和网站上下文，给出更自然的翻译。要在此处获得：",
        "empty_step_1": "前往 AI 翻译 › 设置，将“启用 AI 翻译”设为“仅规则”、“仅实时编辑器”或“规则与实时编辑器”。",
        "empty_step_2": "通过匹配此页面的规则来应用，或在实时编辑器中逐页启用。",
        "empty_step_3": "AI 增强翻译生成后将显示在此处，并会消耗您的 AI 积分。",
        "open_settings": "打开 AI 翻译设置",
        "open_editor": "打开实时编辑器",
        "overrides_selection": "已保存您的选择，但由于 AI 翻译设置中的“覆盖手动翻译和选定的翻译”为“是”，将改为显示此 AI 增强翻译。关闭该设置即可使用您的选择。",
        "overrides_version": "已保存您选择的版本，但由于 AI 翻译设置中的“覆盖手动翻译和选定的翻译”为“是”，将改为显示最新的 AI 增强版本。关闭该设置即可使用所选版本。"
      },
      "manual": {
        "title": "手动翻译",
        "subtitle": "由您撰写 · 优先于自动翻译",
        "empty": "空",
        "saved_but_overridden": "已按您的选择保存，但不会自动显示，因为 AI 翻译设置中的“覆盖手动翻译”为“是”：在关闭该设置之前，AI 增强翻译优先。",
        "ignored": "不会自动显示，因为 AI 翻译设置中的“覆盖手动翻译”为“是”。选择它即可用于此文本。",
        "label": "您的翻译",
        "placeholder": "输入您自己的翻译...",
        "last_updated": "最后编辑于 {{date}}",
        "save_hint": "保存手动翻译后即会生效。",
        "delete": "删除手动翻译",
        "delete_confirm": "请确认删除手动翻译"
      }
    },
    "history": {
      "title": "AI 增强版本",
      "subtitle": "实时编辑器中的每次重新生成都会保留",
      "unknown_model": "未知模型",
      "current": "当前",
      "restore": "恢复此版本",
      "restore_note": "恢复后，该版本将成为当前的 AI 增强翻译。不会删除任何内容。",
      "version_of": "第 {{current}} 版，共 {{total}} 版",
      "hide": "隐藏历史（{{total}}）",
      "show": "显示历史（{{total}}）"
    },
    "choose": {
      "title": "{{language}}翻译 · 选择访客看到的版本",
      "current": "网站当前使用：",
      "priority": "默认优先级：手动 › AI 增强 › 基础。您的选择仅对此翻译保存。",
      "reset": "恢复默认优先级",
      "reset_title": "忽略您对此文本的选择，重新使用默认优先级",
      "resetting": "恢复中..."
    }
  },
  "translations": {
    "title": "翻译管理",
    "description": "列出并编辑所有网站翻译，可视化翻译请使用实时编辑器",
    "filter_languages": "按语言筛选…",
    "filter_original": "按原语言文本筛选",
    "filter_translation": "按翻译文本筛选",
    "table": {
      "original": "原文",
      "language": "语言",
      "action": "操作",
      "base": "基础",
      "ai": "AI 增强",
      "manual": "手动"
    },
    "filter_exact": "精确匹配",
    "badge": {
      "active": "生效中",
      "overrides_manual": "覆盖手动"
    },
    "cell": {
      "none": "无",
      "not_generated": "未生成",
      "ignored": "已忽略 – AI 规则优先"
    },
    "tabs": {
      "all": "全部",
      "manual": "有手动",
      "ai": "有 AI 增强",
      "base": "仅基础"
    },
    "levels_hint": "每个文本最多有 3 个层级 — 标记为“生效中”的是访客看到的版本。"
  },
  "url": {
    "main": {
      "parent": "网址",
      "edit": "编辑网址翻译"
    },
    "form": {
      "original": {
        "title": "{{language}} 原文"
      },
      "translation": {
        "title": "{{language}} 网址译文",
        "description": "您想要覆盖的网址",
        "placeholder": "网址译文重定向",
        "invalid_full": "格式不正确，仅需修改译文的路径部分",
        "invalid": "提供了无效的网址/路径"
      }
    }
  },
  "urls": {
    "title": "网址管理",
    "description": "列出并编辑网站所有已翻译的网址（高级操作，注意 404 错误）",
    "filter_languages": "按语言筛选…",
    "filter_original": "按原语言文本筛选",
    "filter_translation": "按翻译文本筛选",
    "table": {
      "original": "原文",
      "language": "语言",
      "url": "已译网址",
      "action": "操作",
      "edited": "原文已被修改"
    }
  }
}
